import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { getCookie } from 'cookies-next';
import AdminLayout from './layouts/admin';
import SignInDefault from 'views/auth/signIn/SignInDefault';
import Encuestas from 'views/admin/main/ERP/Candidatos/Encuestas';
import initialTheme from './theme/theme';
import PortalCiudadano from 'views/PortalCiudadano/Portal';
import Success from 'views/PortalCiudadano/ok';
import Fail from 'views/PortalCiudadano/fail';
import TurnosRealTime from 'views/Turnos_PUB/Turnos';

// Componente de protección
const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const token = getCookie('sesion_t');

  if (!token) {
    // Redirigir al componente SignIn si no hay token
    return <Navigate to="/auth/signin" replace />;
  }

  return children;
};

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  return (
    <ChakraProvider theme={currentTheme}>
      <Routes>
        {/* Ruta protegida para admin */}
        <Route
          path="admin/*"
          element={
            <ProtectedRoute>
              <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
            </ProtectedRoute>
          }
        />
        {/* Redirección a la pantalla de SignIn */}
        <Route path="/auth/signin" element={<SignInDefault />} />
        {/* Ruta de Encuestas */}
        {/* <Route path="encuesta/:id" element={<Encuestas />} /> */}
        <Route path="portal" element={<PortalCiudadano />} />
        <Route path="turnos" element={<TurnosRealTime />} />

        <Route path="success" element={<Success />} />

        <Route path="fail" element={<Fail />} />

        {/* Redirección a admin por defecto */}
        <Route path="/" element={<Navigate to="/admin" replace />} />
      </Routes>
    </ChakraProvider>
  );
}
